import script from "./Dialog2.vue?vue&type=script&setup=true&lang=ts"
export * from "./Dialog2.vue?vue&type=script&setup=true&lang=ts"

import "./Dialog2.vue?vue&type=style&index=0&id=4c675fc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c675fc2"]])

export default __exports__